/* eslint-disable react/prop-types */
// Thermometer.jsx
import React from 'react'
import High from './High'
import Low from './Low'

const ThermometerDefault = function ThermometerDefault ({ high, low, style }) {
  return (
    <Thermometer high={high} low={low} style={style} />
  )
}

export default ThermometerDefault

const Thermometer = function Thermometer ({ high, low, style }) {
  const defaultStyle = {
    stroke: '#284047',
    fill: '#284047',
    strokeWidth: 2,
    strokeLineCap: 'butt',
    strokeLineJoin: 'miter',
    strokeMiterLimit: 4,
  }

  const svgStyle = { ...defaultStyle, ...style }

  return (
    <svg
      viewBox='0 0 75 75'
    >
      <g
        style={{
          transform: 'translate(20px, 4px) scale(1.7)',
        }}
      >
        <g
          style={svgStyle}

        >
          <description>thermometer icon</description>
          <title>temperature</title>
          <path fill='none' d='m 4.5,22.7 c 0,0 -2.4,2.8 -2.4,6.35 0,3.6 3.9,6.4 7.4,6.35 3.5,0 7.6,-2.2 7.9,-6.4 0.3,-4.2 -2.6,-6.3 -2.6,-6.3 0,0 0.3,-11.5 0,-14 -0.3,-2.5 -3.1,-4 -5.3,-4 -2.2,0 -4.9,1.6 -5,4 -0.1,2.3 0,14 0,14 z' />
          <circle cx='9.5' cy='28.2' r='2.4' />
          <path d='m 9.6,13.8 0,12 v 0' />
          <path d='m 17.2,12 c 3.7,0 3.7,0 3.7,0 v 0 0' />
          <path d='m 17.2,16 c 3.7,0 3.7,0 3.7,0 v 0 0' />
          <path d='m 17.2,20 c 3.7,0 3.7,0 3.7,0 v 0 0' />
        </g>
      </g>

      {!!high && (
        <g id='high' transform='translate(46,36) scale(.4)'>
          <High />
        </g>
      )}

      {!!low && (
        <g id='low' transform='translate(46,36) scale(.4)'>
          <Low />
        </g>
      )}
    </svg>
  )
}
